<template>
  <v-dialog v-model="showTable" persistent scrollable max-width="75%">
    <v-card class="px-3 py-0">
      <v-card-title class="pa-0">
        <v-col class="text-right pb-0 pt-1 px-0">
          <v-btn icon dark @click="cleanClose()">
            <v-icon color="primary">mdi-close</v-icon>
          </v-btn>
        </v-col>
      </v-card-title>
      <v-card-text class="pt-0 pb-2">
        <LoteErro 
        v-if="critica?.Erro[0]?.ErrorCode !== null|| critica?.Erros[0]?.ErrorCode !== null"
        :itemsErro="critica"
        :showType="errorType"
        :cleanClose="() => cleanClose()"
        :dadosLote="items"
        :envioAutomatico="parameter"
        :noLine="true" />
        <LoteErro
         v-else
        :critica="critica"
        :showType="errorType"
        :cleanClose="() => cleanClose()"
        :dadosLote="items"
        :envioAutomatico="parameter"
        :noLine="true" />


      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import LoteErro from '../dados_cronograma/LoteErro'
export default {
  components: {
    LoteErro
  },
  data() {
    return {
      showTable: false,
      items: {
        fl_tratado: 1,
        etapa: 20
      },
      parameter: true,
      errorType: 2,
    };
  },
    watch: {
    dialog(val) {
            this.showTable = val
    },
  },
  methods: {
    cleanClose() {
      this.showClose()
    }
  },
  props: {
    dialog: Boolean,
    showClose: Function,
    critica: Object,
  },
};
</script>

<style></style>